module.exports = new Promise(resolve => {
            let remoteUrl = window._env_.APP_DCP_CONSOLE_URL + "/mfs/reporting/remoteEntry.js"
            if (false){
              remoteUrl = "http://localhost:4207/remoteEntry.js"
              // remoteUrl = "https://console.druva.com/mfs/reporting/remoteEntry.js"
            }
            const script = document.createElement('script')
            script.src = remoteUrl
            script.onload = () => {
              // the injected script has loaded and is available on window
              // we can now resolve this Promise
              const proxy = {
                get: (request) => window.reporting.get(request),
                init: (arg) => {
                  try {
                    return window.reporting.init(arg)
                  } catch(e) {
                    console.log('remote container already initialized')
                  }
                }
              }
              resolve(proxy)
            }
            script.onerror = (error) => {
              console.error('Error loading reporting remote container', error);
              const proxy = {
                get: () => {
                  return Promise.resolve(() => ({
                    __esModule: true,
                    mount: () => ({ unmount: () => {} }),
                    default: () => null,
                  }));
                },
                init: () => {
                  return;
                }
              }
              resolve(proxy)
            }
            // inject this script with the src set to the versioned remoteEntry.js
            document.head.appendChild(script);
          })
          ;